import { useSyncExternalStore } from "react";
import { Lock, LockOpen } from "lucide-react";
import { cn } from "@pontimed/ui";
import { isVaultUnlocked, getVaultUnlockExpiry } from "@/lib/vault-unlock";

// Module-level store
let currentValue = typeof window !== "undefined" ? isVaultUnlocked() : false;
const listeners = new Set<() => void>();

function notify() {
  currentValue = isVaultUnlocked();
  listeners.forEach((l) => l());
}

let expiryTimer: ReturnType<typeof setTimeout> | null = null;
function scheduleExpiry() {
  if (typeof window === "undefined") return;
  if (expiryTimer) clearTimeout(expiryTimer);
  const expiry = getVaultUnlockExpiry();
  if (expiry) {
    const remaining = expiry - Date.now();
    if (remaining > 0) {
      expiryTimer = setTimeout(notify, remaining);
    }
  }
}

// Global listeners (once)
if (typeof window !== "undefined") {
  window.addEventListener("vault-unlocked", () => {
    notify();
    scheduleExpiry();
  });
  window.addEventListener("vault-protection-changed", notify);
  scheduleExpiry();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): boolean {
  return currentValue;
}

function getServerSnapshot(): boolean {
  return false;
}

interface ProtectionLockIconProps {
  isProtected: boolean;
  className?: string;
}

export function ProtectionLockIcon({ isProtected, className }: ProtectionLockIconProps) {
  const unlocked = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  if (!isProtected) {
    return <LockOpen className={cn("opacity-40", className)} />;
  }

  if (unlocked) {
    return <LockOpen className={cn(className)} />;
  }

  return <Lock className={cn(className)} />;
}
